import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../redux/hooks";
import {
    closeGlobalDialog,
    globalDialogProps,
    setGlobalDialog
} from "../redux/reducers/ui";

const useGlobalDialog = () => {
    const { globalDialog } = useAppSelector((state) => state.ui);

    const dispatch = useDispatch();

    const open = useCallback(
        (title: string, body: JSX.Element | string, hidingAction?: boolean) => {
            const payload: globalDialogProps = {
                open: true,
                title,
                body,
                hidingAction
            };
            dispatch(setGlobalDialog(payload));
        },
        [dispatch]
    );

    const close = useCallback(() => {
        dispatch(closeGlobalDialog());
    }, [dispatch]);

    return { globalDialog, open, close };
};

export default useGlobalDialog;
